// 港口管理页面
export const PORT_PAGE_UUID = 'e591efe4-eb4d-4ee9-b422-8d5b4d309d49'

// 管理港口
export const PORT_ACTION_UUID = '6c1105f9-8c4e-4618-bab3-2f0a2b7cabca'
